export function addOrientationListener(orientationHandler) {
    return window.addEventListener('resize', orientationHandler);
}

export function getOrientation(){
    return window.innerHeight > window.innerWidth ? "portrait" : "landscape"
}

export function isTooNarrow(width, height){
    return (height / width) > 0.75
}
